import React from "react";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";

const messages = [
    "voluntary_consent",
    "consent_para_1",
    "consent_para_2",
    "consent_para_3",
    "consent_para_4",
    "consent_para_5",
    "consent_para_6",
    "consent_para_7",
    "consent_para_8",
];

const ConsentDetails = ({ backSlideEffect }) => {
    useSideModalScrollToTop();
    const { formatMessage } = useFormattedMessage();

    return (
        <div className={`link-sparkasse-consent-detail-screen p-6 ${backSlideEffect}`}>
            <h5 className="mt-0">{formatMessage(messages[0])}</h5>
            {messages.slice(1).map((msg, index) => (
                <p key={index} className="mb-6 text-16">
                    {formatMessage(msg)}
                </p>
            ))}
        </div>
    );
};

export default ConsentDetails;
